import React from "react";
import "./styles.scss";

const CardBox = ({
    children,
    title = "title",
    confirmButtonText = "Confirm",
    cancelButtonText = "Cancel",
    onClickConfirmButton,
    onClickCancelButton,
    confirmButtonDisabled,
    cancelButtonDisabled,
    options,
    type = "",
    // options = [{ icon: 'icon  icon-cancel', title: '', onClick: () => {} }],
}) => {
    const handleSubmit = (event) => {
        event.preventDefault();
        onClickConfirmButton && onClickConfirmButton();
    };
    return (
        <div className={`card-box ${type === "warning" ? "card-box-warning" : ""}`}>
            <form onSubmit={handleSubmit}>
                <div className="card-box-header">
                    <div className="card-box-header-title">{title}</div>
                    <div className="card-box-header-options">
                        {options?.map((option, index) => {
                            const { icon, title, onClick, disabled } = option;
                            return (
                                <div key={"option-" + index} className="mx-5">
                                    <i
                                        className={icon}
                                        title={title}
                                        onClick={() => {
                                            !disabled && onClick();
                                        }}
                                        disabled={disabled}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="card-box-body">{children}</div>
                <div className="card-box-footer">
                    {onClickCancelButton && (
                        <button
                            type="button"
                            disabled={cancelButtonDisabled}
                            className={` btn  btn-cancel ${onClickConfirmButton ? "btn-half" : "btn-full"}`}
                            onClick={onClickCancelButton}
                        >
                            {cancelButtonText}
                        </button>
                    )}
                    {onClickConfirmButton && (
                        <button
                            type="submit"
                            disabled={confirmButtonDisabled}
                            className={` btn  btn-confirm ${onClickCancelButton ? "btn-half" : "btn-full"}`}
                        >
                            {confirmButtonText}
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
};
export default CardBox;
